/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class StringUtil {
    public static toCamelCase(value: string): string {
        const firstLetter = value.substring(0, 1);
        return firstLetter.toLowerCase() + value.substring(1);
    }

    public static toTitleCase(value: string): string {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    public static isEmpty(value: string): boolean {
        return value === "";
    }

    public static isNullOrEmpty(value?: string): boolean {
        return value === null || StringUtil.isEmpty(value ?? "");
    }

    public static isNullOrWhitespace(value?: string | null) {
        return !value || value.trim().length === 0;
    }

    public static isNotNullOrWhitespace(value?: string | null) {
        return !StringUtil.isNullOrWhitespace(value);
    }

    public static isSomeNotNullOrWhitespace(...values: (string | null | undefined)[]) {
        return values.some(StringUtil.isNotNullOrWhitespace);
    }

    public static isWhitespace(value: string): boolean {
        if (value == null || typeof(value) !== "string") {
            return false
        }

        return value.match(/^\s+$/) !== null;
    }

    public static left(value: string, length: number) {
        return value.substring(0, length);
    }

    public static ensureTrailingSlash(value: string): string {
        return value.endsWith("/") ? value : value + "/";
    }

    public static equalsIgnoreCase(value1?: string, value2?: string) {
        return value1?.toLowerCase() === value2?.toLowerCase();
    }

    public static startsWithIgnoreCase(aString: string, searchString: string): boolean {
        return aString.toLowerCase().startsWith(searchString.toLowerCase());
    }
}

export const capitalize = StringUtil.toTitleCase;